import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";
import { getRapportFlowData } from "#/modules/rapporten/rapporten.functions";
import { getAccountUserInfo } from "#/modules/user.account-settings/user.functions";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/reports/flow/$id",
)({
  loader: async ({ params }) => {
    // userInfo feeds the ondertekening line (docent alias) in the flow-summary sidebar.
    const [flowData, userInfo] = await Promise.all([
      getRapportFlowData({ data: { rapportId: params.id } }),
      getAccountUserInfo(),
    ]);
    return { ...flowData, userInfo };
  },
  component: RapportFlowLayout,
  errorComponent: RapportFlowError,
});

function RapportFlowLayout() {
  return <Outlet />;
}

function RapportFlowError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
